/**
 * Dryer Balls Mobile Optimizations
 * Minimal JavaScript - only for padding-top fix
 */

(function() {
  'use strict';
  
  // Only run on mobile
  if (window.innerWidth > 768) return;
  
  // Remove inline padding-top from global wrapper
  function removePaddingTop() {
    const globalWrapper = document.querySelector('.global-wrapper__product');
    if (globalWrapper) {
      globalWrapper.style.paddingTop = '0';
    }
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removePaddingTop);
  } else {
    removePaddingTop();
  }
  
})();